/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Receipt_Timeline_PeopleInputs */



/**
* | output |
* | --- |
* | "{count} people" |
*
* @param {Receipt_Timeline_PeopleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_timeline_people = /** @type {((inputs: Receipt_Timeline_PeopleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Timeline_PeopleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Personen`)
	return /** @type {LocalizedString} */ (`${i?.count} people`)
});